module.exports = __webpack_public_path__ + "static/media/morse-code2.3f943ffd.aac";